import { gql } from '@apollo/client';
export const USER_PREFERENCE_FIELDS = gql `
  fragment UserPreferenceFields on UserPreference {
    id
    key
    value
    createdAt
    updatedAt
  }
`;
export const USER_PREFERENCES = gql `
  ${USER_PREFERENCE_FIELDS}
  query USER_PREFERENCES {
    userPreferences {
      ...UserPreferenceFields
    }
  }
`;
export const SAVE_USER_PREFERENCE = gql `
  ${USER_PREFERENCE_FIELDS}
  mutation SAVE_USER_PREFERENCE($input: UserPreferenceInput!) {
    saveUserPreference(input: $input) {
      ...UserPreferenceFields
    }
  }
`;
